module.exports = "../../../../platform/assets/pageMainIcon/industry_baobiaochaxunlei2.svg";